<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <mat-form-field class="w-100-p mb-12" *ngIf="showSelectRole">
        <mat-label>{{ 'GENERAL.PROPERTY.ROLE' | translate }}</mat-label>
        <mat-select [formControl]="selectedRole">
            <mat-option *ngFor="let userTeamRole of filteredUserTeamRoles" [value]="userTeamRole.value">
                {{ userTeamRole.translationLabel | translate | titlecase }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="bg-gray-100 p-16 rounded-lg mb-24" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="selectPerformanceTemplateTeams">
        <div fxLayout="row" fxLayoutAlign="start center" class="pr-12">
            <mat-icon class="text-gray-400 mr-8">info</mat-icon>
            <span class="text-gray-600">{{ 'PERFORMANCE_REVIEW.TOOLTIP.MANAGE_TEAMS' | translate }}</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" (click)="onManageTeams()" class="cursor-pointer">
            <span class="text-primary-500 text-nowrap">{{ 'TEAMS.DIALOG.MANAGE_TEAMS.TITLE' | translate }}</span>
            <mat-icon class="text-primary-500">keyboard_arrow_right</mat-icon>
        </div>
    </div>

    <ng-container *ngIf="selectedTeams.length">
        <h3 class="mt-0 mb-8 text-base font-medium text-gray-600">{{ 'TEAMS.DIALOG.SELECTED_TEAMS.LABEL' | translate }}</h3>
        <mat-chip-set class="chip-list wrap mb-32">
            <mat-chip class="chip maxbrain-500" (removed)="onDeselect(selectedTeam)" *ngFor="let selectedTeam of selectedTeams">
                {{ selectedTeam.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree border">
        <mat-tree-node *matTreeNodeDef="let node">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-16 pr-24">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="tree-node-icon-spacer mr-8" fxLayoutAlign="center center">
                        <mat-icon class="circle-icon">circle</mat-icon>
                    </div>
                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                        <mat-icon svgIcon="team"></mat-icon>
                    </div>
                    <h3>{{ node.name }}</h3>
                </div>

                <app-flat-button
                    [label]="'GENERAL.BUTTON.SELECT'"
                    (onClick)="onSelect(node)"
                    [disabled]="(selectedNode && selectedNode.id !== node.id) || (selectPerformanceTemplateTeams ? !node.isSelectable : false)"
                    *ngIf="!isNodeSelected(node) && !node.isParentSelected; else showUnselectOrParentSelected"
                ></app-flat-button>

                <ng-template #showUnselectOrParentSelected>
                    <app-white-button *ngIf="isNodeSelected(node) && !node.isParentSelected" [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>

                    <span class="font-medium text-gray-400" *ngIf="node.isParentSelected">{{ 'GENERAL.LABEL.SELECTED' | translate }}</span>
                </ng-template>
            </div>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-16 pr-24">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-8" (click)="toggleNode(node)" [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>
                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                        <mat-icon svgIcon="team"></mat-icon>
                    </div>
                    <h3>{{ node.name }}</h3>
                </div>

                <app-flat-button
                    [label]="'GENERAL.BUTTON.SELECT'"
                    (onClick)="onSelect(node)"
                    [disabled]="(selectedNode && selectedNode.id !== node.id) || (selectPerformanceTemplateTeams ? !node.isSelectable : false)"
                    *ngIf="!isNodeSelected(node) && !node.isParentSelected; else showUnselectOrParentSelected"
                ></app-flat-button>

                <ng-template #showUnselectOrParentSelected>
                    <app-white-button *ngIf="isNodeSelected(node) && !node.isParentSelected" [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>

                    <span class="font-medium text-gray-400" *ngIf="node.isParentSelected">{{ 'GENERAL.LABEL.SELECTED' | translate }}</span>
                </ng-template>
            </div>

            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                <div *ngIf="node.isLoading" class="shimmer-container pb-4 pt-12">
                    <div class="shimmer" *ngFor="let item of [1, 2, 3]">
                        <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                            <div class="shimmer-square animate mr-12"></div>
                            <div class="shimmer-title max-w-sm animate mb-0"></div>
                        </div>
                    </div>
                </div>
                <ng-container matTreeNodeOutlet></ng-container>
            </div>
        </mat-nested-tree-node>
    </mat-tree>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <div class="example-spacer"></div>
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onSave()" [disabled]="!selectedTeams.length || (showSelectRole && !selectedRole.value)">></app-flat-button>
</div>
